import { dailyImageNumber } from "./utils/date";

type Props = {
  caption?: string;
};

export function DailyImage({ caption = "today's frame ♡" }: Props) {
  const n = dailyImageNumber();
  const src = `/assets/${n}.webp`;
  return (
    <figure className="polaroid" aria-label={`Photo of the day, ${n} of 13`}>
      <img className="polaroid-img" src={src} alt="" loading="lazy" />
      <figcaption className="polaroid-caption">{caption}</figcaption>
    </figure>
  );
}
